module.exports = __webpack_public_path__ + "static/media/banner3.952696f3.jpg";